import { find } from 'lodash';
import apolloClient from 'store/apolloClient';
import apiCall from 'shared/utils/apiCall';

import { getCurrentLanguage } from 'modules/language/selectors/language';
import { addModal } from 'modules/messageSystem/actions/addModal';
import { MODAL_ACCESSIBILITY_STATEMENT } from 'modules/messageSystem/constants/modalCodes';

import * as services from '../services/organizationDetails';


const fetchOrganizationAccessibilityStatement = () => (dispatch, getState) => {
  const state = getState();
  const { selectedOrganizationToken: orgId } = state.auth.organizations;
  const locale = getCurrentLanguage();

  const apiCallParams = {
    query: services.FETCH_ORGANIZATION_ACCESSIBILITY_STATEMENT,
    variables: { orgId, locale },
    fetchPolicy: 'no-cache',
  };

  return apiCall(apolloClient.query, apiCallParams)
    .then(({ data: { organizationDetails: { config } } }) => config.accessibilityStatement[0].value)
    .catch((err) => { throw err; });
};

const fetchSiteAccessibilityStatement = () => () => {
  const apiCallParams = {
    query: services.FETCH_SITE_ACCESSIBILITY_STATEMENT,
    fetchPolicy: 'no-cache',
  };

  return apiCall(apolloClient.query, apiCallParams)
    .then(({ data: { organizationsDetails } }) => {
      const locale = getCurrentLanguage().toUpperCase();
      return find(organizationsDetails[0].config.accessibilityStatement, { locale }).value;
    })
    .catch((err) => { throw err; });
};


export const showAccessibilityStatementModal = () => (dispatch, getState) => {
  const state = getState();
  const { selectedOrganizationToken } = state.auth.organizations;

  const fetchFn = selectedOrganizationToken ? fetchOrganizationAccessibilityStatement : fetchSiteAccessibilityStatement;

  return dispatch(fetchFn())
    .then((accessibilityStatement) => {
      dispatch(addModal({
        testId: 'accessibility-statement-modal',
        typeId: MODAL_ACCESSIBILITY_STATEMENT,
        body: accessibilityStatement,
      }));
    });
};
